var _g, _rect, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSponsoredProductSoon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7450_49120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6694 13.161C13.5915 13.1776 13.4587 13.2238 13.3745 13.2638C13.1642 13.3635 12.8841 13.6373 12.7824 13.8427C12.6337 14.1433 12.6414 13.8748 12.648 18.5286L12.654 22.7527L12.7152 22.9166C12.8596 23.3035 13.1646 23.5959 13.5542 23.7208L13.7205 23.7741H18.4516H23.1827L23.349 23.7208C23.7386 23.5959 24.0436 23.3035 24.188 22.9166L24.2492 22.7527L24.2552 18.5286C24.2618 13.8748 24.2695 14.1433 24.1207 13.8427C24.0193 13.6377 23.739 13.3634 23.5296 13.2642C23.2253 13.1199 23.5288 13.128 18.4403 13.1295C14.6302 13.1306 13.7862 13.1362 13.6694 13.161ZM20.5408 15.1019C20.8076 15.183 21.0551 15.3716 21.2213 15.6203C21.6274 16.2284 21.3895 17.0645 20.7181 17.3883C19.9027 17.7817 18.9646 17.2532 18.8912 16.3591C18.8432 15.7746 19.284 15.2035 19.8868 15.0691C20.0685 15.0286 20.3452 15.0425 20.5408 15.1019ZM16.8585 17.6105C16.9047 17.6338 16.973 17.6841 17.01 17.7222C17.0471 17.7604 17.578 18.4321 18.1899 19.215C19.2124 20.523 19.3124 20.6437 19.4242 20.7054C19.5698 20.7858 19.7526 20.7953 19.8953 20.7299C19.9437 20.7077 20.1525 20.5278 20.3593 20.33C20.7566 19.9501 20.8009 19.9221 21.0056 19.9218C21.1405 19.9216 21.3083 20.0123 21.4051 20.1377C21.592 20.3796 22.7962 22.0721 22.8455 22.1621C22.9371 22.3291 22.9014 22.4818 22.7548 22.5499C22.6833 22.5831 22.3215 22.5862 18.5386 22.5862C14.5547 22.5862 14.3976 22.5846 14.3214 22.545C14.2162 22.4903 14.1401 22.3777 14.1408 22.2776C14.1411 22.2336 14.1646 22.1426 14.1931 22.0755C14.3062 21.8086 16.4166 17.7527 16.4734 17.6931C16.5919 17.5688 16.7207 17.5411 16.8585 17.6105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 35.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 8,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1743 14.2191C46.1119 14.2323 46.0057 14.2693 45.9383 14.3012C45.7701 14.381 45.546 14.6001 45.4647 14.7644C45.3457 15.0049 45.3518 14.7901 45.3571 18.5131L45.362 21.8924L45.4109 22.0235C45.5264 22.333 45.7705 22.5669 46.0821 22.6669L46.2151 22.7095H50H53.7849L53.9179 22.6669C54.2296 22.5669 54.4736 22.333 54.5892 22.0235L54.6381 21.8924L54.6429 18.5131C54.6482 14.7901 54.6544 15.0049 54.5353 14.7644C54.4542 14.6004 54.2299 14.381 54.0624 14.3016C53.819 14.1862 54.0618 14.1926 49.9909 14.1938C46.9429 14.1947 46.2677 14.1992 46.1743 14.2191ZM51.6714 15.7718C51.8848 15.8366 52.0829 15.9875 52.2157 16.1865C52.5407 16.673 52.3503 17.3418 51.8132 17.6009C51.1609 17.9156 50.4104 17.4928 50.3517 16.7775C50.3133 16.3099 50.666 15.853 51.1482 15.7455C51.2935 15.7131 51.5149 15.7242 51.6714 15.7718ZM48.7255 17.7786C48.7625 17.7973 48.8171 17.8375 48.8468 17.868C48.8764 17.8986 49.3012 18.4359 49.7907 19.0622C50.6086 20.1086 50.6887 20.2052 50.7781 20.2546C50.8946 20.3189 51.0408 20.3264 51.155 20.2741C51.1937 20.2564 51.3607 20.1125 51.5262 19.9542C51.844 19.6503 51.8795 19.6279 52.0432 19.6277C52.1511 19.6276 52.2854 19.7001 52.3629 19.8004C52.5123 19.9939 53.4757 21.3479 53.5152 21.4199C53.5884 21.5535 53.5599 21.6757 53.4426 21.7301C53.3854 21.7567 53.096 21.7592 50.0696 21.7592C46.8825 21.7592 46.7568 21.7579 46.6959 21.7263C46.6117 21.6825 46.5509 21.5924 46.5514 21.5123C46.5516 21.4771 46.5704 21.4044 46.5932 21.3506C46.6837 21.1371 48.372 17.8924 48.4175 17.8447C48.5123 17.7453 48.6153 17.7232 48.7255 17.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 31.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 35.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 8,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7227 14.2191C77.6603 14.2323 77.5541 14.2693 77.4867 14.3012C77.3184 14.381 77.0944 14.6001 77.0131 14.7644C76.894 15.0049 76.9002 14.7901 76.9055 18.5131L76.9103 21.8924L76.9592 22.0235C77.0748 22.333 77.3188 22.5669 77.6305 22.6669L77.7635 22.7095H81.5484H85.3333L85.4663 22.6669C85.778 22.5669 86.022 22.333 86.1375 22.0235L86.1865 21.8924L86.1913 18.5131C86.1966 14.7901 86.2027 15.0049 86.0837 14.7644C86.0025 14.6004 85.7783 14.381 85.6108 14.3016C85.3673 14.1862 85.6102 14.1926 81.5393 14.1938C78.4912 14.1947 77.816 14.1992 77.7227 14.2191ZM83.2198 15.7718C83.4332 15.8366 83.6312 15.9875 83.7641 16.1865C84.089 16.673 83.8987 17.3418 83.3616 17.6009C82.7093 17.9156 81.9588 17.4928 81.9001 16.7775C81.8617 16.3099 82.2143 15.853 82.6966 15.7455C82.8419 15.7131 83.0633 15.7242 83.2198 15.7718ZM80.2739 17.7786C80.3109 17.7973 80.3655 17.8375 80.3951 17.868C80.4248 17.8986 80.8495 18.4359 81.3391 19.0622C82.157 20.1086 82.237 20.2052 82.3265 20.2546C82.443 20.3189 82.5892 20.3264 82.7034 20.2741C82.7421 20.2564 82.9091 20.1125 83.0746 19.9542C83.3924 19.6503 83.4279 19.6279 83.5916 19.6277C83.6995 19.6276 83.8337 19.7001 83.9112 19.8004C84.0607 19.9939 85.0241 21.3479 85.0635 21.4199C85.1368 21.5535 85.1082 21.6757 84.991 21.7301C84.9338 21.7567 84.6444 21.7592 81.618 21.7592C78.4309 21.7592 78.3052 21.7579 78.2443 21.7263C78.1601 21.6825 78.0992 21.5924 78.0998 21.5123C78.1 21.4771 78.1188 21.4044 78.1416 21.3506C78.2321 21.1371 79.9204 17.8924 79.9658 17.8447C80.0607 17.7453 80.1637 17.7232 80.2739 17.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 31.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 35.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44.7998,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6259 51.0189C14.5635 51.0321 14.4573 51.0691 14.3899 51.101C14.2217 51.1808 13.9976 51.3999 13.9163 51.5642C13.7973 51.8047 13.8034 51.5899 13.8087 55.3129L13.8136 58.6922L13.8625 58.8233C13.978 59.1328 14.2221 59.3668 14.5337 59.4667L14.6667 59.5093H18.4516H22.2365L22.3695 59.4667C22.6812 59.3668 22.9252 59.1328 23.0408 58.8233L23.0897 58.6922L23.0945 55.3129C23.0998 51.5899 23.106 51.8047 22.9869 51.5642C22.9058 51.4002 22.6815 51.1808 22.514 51.1014C22.2706 50.986 22.5134 50.9924 18.4425 50.9936C15.3945 50.9945 14.7193 50.999 14.6259 51.0189ZM20.123 52.5716C20.3364 52.6364 20.5345 52.7873 20.6673 52.9863C20.9923 53.4728 20.8019 54.1416 20.2648 54.4007C19.6125 54.7154 18.862 54.2926 18.8033 53.5773C18.7649 53.1097 19.1176 52.6528 19.5998 52.5453C19.7451 52.5129 19.9665 52.524 20.123 52.5716ZM17.1771 54.5784C17.2141 54.5971 17.2687 54.6373 17.2984 54.6678C17.328 54.6984 17.7528 55.2358 18.2423 55.862C19.0602 56.9084 19.1403 57.005 19.2297 57.0544C19.3462 57.1187 19.4924 57.1262 19.6066 57.0739C19.6453 57.0562 19.8123 56.9123 19.9778 56.754C20.2956 56.4501 20.3311 56.4277 20.4948 56.4275C20.6027 56.4274 20.737 56.4999 20.8145 56.6002C20.9639 56.7937 21.9273 58.1477 21.9668 58.2197C22.04 58.3533 22.0115 58.4755 21.8942 58.5299C21.837 58.5565 21.5476 58.559 18.5212 58.559C15.3341 58.559 15.2084 58.5578 15.1475 58.5261C15.0633 58.4823 15.0025 58.3922 15.003 58.3121C15.0032 58.2769 15.022 58.2042 15.0448 58.1504C15.1353 57.9369 16.8236 54.6922 16.8691 54.6445C16.9639 54.5451 17.0669 54.523 17.1771 54.5784Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 68.0254,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 44.7998,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1743 51.0189C46.1119 51.0321 46.0057 51.0691 45.9383 51.101C45.7701 51.1808 45.546 51.3999 45.4647 51.5642C45.3457 51.8047 45.3518 51.5899 45.3571 55.3129L45.362 58.6922L45.4109 58.8233C45.5264 59.1328 45.7705 59.3668 46.0821 59.4667L46.2151 59.5093H50H53.7849L53.9179 59.4667C54.2296 59.3668 54.4736 59.1328 54.5892 58.8233L54.6381 58.6922L54.6429 55.3129C54.6482 51.5899 54.6544 51.8047 54.5353 51.5642C54.4542 51.4002 54.2299 51.1808 54.0624 51.1014C53.819 50.986 54.0618 50.9924 49.9909 50.9936C46.9429 50.9945 46.2677 50.999 46.1743 51.0189ZM51.6714 52.5716C51.8848 52.6364 52.0829 52.7873 52.2157 52.9863C52.5407 53.4728 52.3503 54.1416 51.8132 54.4007C51.1609 54.7154 50.4104 54.2926 50.3517 53.5773C50.3133 53.1097 50.666 52.6528 51.1482 52.5453C51.2935 52.5129 51.5149 52.524 51.6714 52.5716ZM48.7255 54.5784C48.7625 54.5971 48.8171 54.6373 48.8468 54.6678C48.8764 54.6984 49.3012 55.2358 49.7907 55.862C50.6086 56.9084 50.6887 57.005 50.7781 57.0544C50.8946 57.1187 51.0408 57.1262 51.155 57.0739C51.1937 57.0562 51.3607 56.9123 51.5262 56.754C51.844 56.4501 51.8795 56.4277 52.0432 56.4275C52.1511 56.4274 52.2854 56.4999 52.3629 56.6002C52.5123 56.7937 53.4757 58.1477 53.5152 58.2197C53.5884 58.3533 53.5599 58.4755 53.4426 58.5299C53.3854 58.5565 53.096 58.559 50.0696 58.559C46.8825 58.559 46.7568 58.5578 46.6959 58.5261C46.6117 58.4823 46.5509 58.3922 46.5514 58.3121C46.5516 58.2769 46.5704 58.2042 46.5932 58.1504C46.6837 57.9369 48.372 54.6922 48.4175 54.6445C48.5123 54.5451 48.6153 54.523 48.7255 54.5784Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 68.0254,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 44.7998,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7227 51.0189C77.6603 51.0321 77.5541 51.0691 77.4867 51.101C77.3184 51.1808 77.0944 51.3999 77.0131 51.5642C76.894 51.8047 76.9002 51.5899 76.9055 55.3129L76.9103 58.6922L76.9592 58.8233C77.0748 59.1328 77.3188 59.3668 77.6305 59.4667L77.7635 59.5093H81.5484H85.3333L85.4663 59.4667C85.778 59.3668 86.022 59.1328 86.1375 58.8233L86.1865 58.6922L86.1913 55.3129C86.1966 51.5899 86.2027 51.8047 86.0837 51.5642C86.0025 51.4002 85.7783 51.1808 85.6108 51.1014C85.3673 50.986 85.6102 50.9924 81.5393 50.9936C78.4912 50.9945 77.816 50.999 77.7227 51.0189ZM83.2198 52.5716C83.4332 52.6364 83.6312 52.7873 83.7641 52.9863C84.089 53.4728 83.8987 54.1416 83.3616 54.4007C82.7093 54.7154 81.9588 54.2926 81.9001 53.5773C81.8617 53.1097 82.2143 52.6528 82.6966 52.5453C82.8419 52.5129 83.0633 52.524 83.2198 52.5716ZM80.2739 54.5784C80.3109 54.5971 80.3655 54.6373 80.3951 54.6678C80.4248 54.6984 80.8495 55.2358 81.3391 55.862C82.157 56.9084 82.237 57.005 82.3265 57.0544C82.443 57.1187 82.5892 57.1262 82.7034 57.0739C82.7421 57.0562 82.9091 56.9123 83.0746 56.754C83.3924 56.4501 83.4279 56.4277 83.5916 56.4275C83.6995 56.4274 83.8337 56.4999 83.9112 56.6002C84.0607 56.7937 85.0241 58.1477 85.0635 58.2197C85.1368 58.3533 85.1082 58.4755 84.991 58.5299C84.9338 58.5565 84.6444 58.559 81.618 58.559C78.4309 58.559 78.3052 58.5578 78.2443 58.5261C78.1601 58.4823 78.0992 58.3922 78.0998 58.3121C78.1 58.2769 78.1188 58.2042 78.1416 58.1504C78.2321 57.9369 79.9204 54.6922 79.9658 54.6445C80.0607 54.5451 80.1637 54.523 80.2739 54.5784Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 68.0254,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 69,
    rx: 5.5,
    stroke: "var(--secondary-1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7450_49120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsoredProductSoon);
export default __webpack_public_path__ + "static/media/sponsored-product-soon.698ca54241a7e43eb204e2fc98971c3d.svg";
export { ForwardRef as ReactComponent };